import { MakeCall } from './createMakeCall';

export interface ResponseObject {
  Rooms: number;
  Cities: number;
  Countries: number;
}

const getGlobalCounters = (makeCall: MakeCall) => () =>
  makeCall<ResponseObject>('GET', `/api/v2/listings/global-counters`);
export { getGlobalCounters };
